import React from 'react';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import fr from 'facet-rest';
import {
  FDBox, FDContentContainer, FDStack,
} from '@facet-wealth/design';
import { LottieLoadingLayout } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import StepNavigationFooter from 'Packages/FacetDesign/Components/Experimental/StepNavigationFooter';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  TaxDiagnosticHeaderLottiePicker,
} from 'Views/Page/Content/Templates/TaxDiagnosticCommon/TaxDiagnosticHeaderLottie/TaxDiagnosticHeaderLottiePicker';
import { ModuleProgressStepper } from 'Components/ComponentLibrary/Organisms/ModuleProgressStepper/ModuleProgressStepper';
import { TaxYearOptionsDropdown } from 'Views/Page/Content/Templates/TaxDiagnosticCommon/TaxYearOptionsDropdown';


const useStyles = buildUseStyles('TaxDiagnosticWrapperLayout', (_) => ({
  root: {
    animation: '$fade-in 1s',
    maxWidth: '100%',
  },
  '@keyframes fade-in': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
}));

export const TaxDiagnosticWrapperLayout = ({ children }) => {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  useBoneBackgroundColor();

  const { displayErrorMessage } = useSnackbarContext();
  const { resource } = useMetaLayoutContext();
  const { setPageContentCollection, loadPageContentLink } = usePageContentContext();

  const handleNext = async () => {
    try {
      setLoading(true);
      const nextStepColl = await resource.submit();
      setPageContentCollection(nextStepColl);
    } catch (err) {
      displayErrorMessage(err, err.errors);
    } finally {
      setLoading(false);
    }
  };

  const maybeHandlePrevious = resource.withRelationship(fr.relationships.previousLink.name,
    (rel) => () => loadPageContentLink(rel.link('related')),
    () => null);

  return (
    <>
      <FDContentContainer maxWidth="md">
        <LottieLoadingLayout>
          <FDStack direction={'column'} justifyContent={'center'} alignItems={'center'} paddingY={2} spacing={4}>
            <FDStack direction={'column'} alignItems={'center'} spacing={2}>
              <MetaControlField attr={'taxYearHeader'} />
              <TaxYearOptionsDropdown resource={resource} />
            </FDStack>
            <MetaControlField attr={'headerText'} />
            <TaxDiagnosticHeaderLottiePicker resource={resource} />
            <ModuleProgressStepper stepCollection={resource.attr('progressSteps')} />
            <div className={classes.root}>
              {children}
            </div>
            <MetaControlField attr="disclosure" />
          </FDStack>
        </LottieLoadingLayout>
      </FDContentContainer>

      <FDBox paddingY={6} />

      <StepNavigationFooter
        onNext={handleNext}
        isLoading={loading}
        label={resource.attr('primaryActionText') || 'Continue'}
        onPrevious={maybeHandlePrevious}
      />
    </>
  );
};

TaxDiagnosticWrapperLayout.defaultProps = {
};

TaxDiagnosticWrapperLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};
